<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    title: {
      type: String,
      default: 'For information:',
    },
  },
}
</script>

<template>
  <svg
    role="img"
    :aria-label="title"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{width, height}"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <g>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M14.5 17.5h-.9c-.424 0-.831-.158-1.131-.44A1.454 1.454 0 0 1 12 16v-3.75a.727.727 0 0 0-.234-.53.828.828 0 0 0-.566-.22h-.7"
      />
      <circle
        cx="11.5"
        cy="7"
        r="1.5"
        fill="currentColor" />
    </g>
  </svg>
</template>
